import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from "@angular/router";
import { DashboardResponse } from '../../../../api/models/dashboardResponse';
import { RouteURLConstants } from '../../../../constants/upplm.constants';

@Component({
    selector: 'qvcancelled',
    template: require('./qvdashboardCancelled.component.html')
})

export class QVCancelledComponent {

    public paramsUrl: string = '?loc=en_US&placardid=';    

    @Input() dataSearch: DashboardResponse;
    @Input() status: any;
    @Output() placardIdDetail = new EventEmitter<string>();

    constructor(private router: Router) { }

    searchInformation() {
        // Call API for search Information 
    }

    goToPlacardVerification() {
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE + this.paramsUrl.concat(this.dataSearch.placardId));
    }
    showDetail(placardId: string) {
        if (placardId.length > 0) {
            this.placardIdDetail.emit(placardId);
        }
    }
}